import React from 'react';
import PropTypes from 'prop-types';
import { H6 } from '@contently/toolkit';
import TextEditor from './TextEditor';
import useStoryContext from '../../hooks/useStoryContext';

const styling = {
  fontWeight: "600",
  fontSize: "30px",
  color: "#333",
  lineHeight: "43px",
  margin: "0"
}

export default function HeadlineTextEditor({ storyId, historyMode, readOnlyMode }) {
  const { storyFormat, subjectLines, contents } = useStoryContext();
  const headline = contents.find(c => c.format === 'headline');

  function StandardStoryHeadline() {
    return (
      <React.Fragment>
          {headline && (
          <TextEditor
            storyId={storyId}
            contentEditorId={headline.uuid}
            contentId={parseInt(headline.id, 10)}
            historyMode={historyMode}
            readOnlyMode={readOnlyMode}
            format="headline"
            style={styling}
          />
        )}
      </React.Fragment>
    )
  }

  function EmailStoryHeadline() {
    return (
      <React.Fragment>
        {subjectLines.length > 0 && subjectLines.map((subjectLine, index) => (
          <React.Fragment key={subjectLine.id}>
            <H6>Subject Line {subjectLines.length > 1 && `#${index + 1}`}</H6>
            {headline && (
              <TextEditor
                storyId={storyId}
                contentEditorId={headline.uuid}
                contentId={parseInt(headline.id, 10)}
                historyMode={historyMode}
                readOnlyMode={readOnlyMode}
                format="emailheadline"
                style={""}
              />
            )}
          </React.Fragment>
        ))}
      </React.Fragment>
    )
  }

  return (
    storyFormat === "email" ? <EmailStoryHeadline /> : <StandardStoryHeadline />
  );
}

HeadlineTextEditor.defaultProps = {
  historyMode: false,
  readOnlyMode: false
};

HeadlineTextEditor.propTypes = {
  storyId: PropTypes.number.isRequired,
  historyMode: PropTypes.bool,
  readOnlyMode: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/javascript/client/components/textEditor/HeadlineTextEditor.jsx